import {
  IconCircleCheck,
  IconInfoCircle,
  IconLoader2,
  IconAlertCircle,
  IconAlertTriangle,
} from "@tabler/icons-react"
import { useTheme } from "@/components/theme/ThemeProvider"
import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme } = useTheme()
  const resolvedTheme: 'dark' | 'light' | 'system' = (theme || 'system') as 'dark' | 'light' | 'system'

  return (
    <Sonner
      theme={resolvedTheme}
      className="toaster group"
      icons={{
        success: <IconCircleCheck className="h-4 w-4" stroke={1.5} />,
        info: <IconInfoCircle className="h-4 w-4" stroke={1.5} />,
        warning: <IconAlertTriangle className="h-4 w-4" stroke={1.5} />,
        error: <IconAlertCircle className="h-4 w-4" stroke={1.5} />,
        loading: <IconLoader2 className="h-4 w-4 animate-spin" stroke={1.5} />,
      }}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
